module.exports = __webpack_public_path__ + "img/wx.2576ae3d.png";